// Campos auditados pelo backend, na ordem em que aparecem no filtro da tela.
// Precisa acompanhar `PRODUCT_CHANGE_FIELDS` do `onii-backend`.
export const PRODUCT_CHANGE_FIELDS = [
  "price",
  "vipPrice",
  "cost",
  "idealQuantity",
  "currentQuantity",
  "vat",
  "validity",
  "catalog"
];

// Como cada campo deve ser apresentado na coluna de valores.
const FIELD_TYPES = {
  price: "money",
  vipPrice: "money",
  cost: "money",
  idealQuantity: "number",
  currentQuantity: "number",
  vat: "percent",
  validity: "date",
  catalog: "catalog"
};

export const getFieldType = field => FIELD_TYPES[field] || "text";

// Um valor ausente é exibido como traço, para diferenciar de zero.
export const isEmptyValue = value =>
  value === null || value === undefined || value === "";
